import confetti from 'canvas-confetti';

const BRAND_COLORS = ['#95F205', '#ffffff', '#ffd700', '#7E8DB8', '#00ff88'];

export function fireCoinConfetti() {
  const burst = (options) => confetti({
    disableForReducedMotion: true,
    colors: BRAND_COLORS,
    zIndex: 10000,
    ...options,
  });

  burst({
    particleCount: 140,
    spread: 110,
    startVelocity: 52,
    origin: { x: 0.5, y: 0.58 },
  });

  burst({
    particleCount: 60,
    spread: 160,
    startVelocity: 38,
    decay: 0.9,
    scalar: 0.9,
    origin: { x: 0.5, y: 0.62 },
  });

  const duration = 1200;
  const end = Date.now() + duration;

  const frame = () => {
    burst({
      particleCount: 4,
      angle: 60,
      spread: 70,
      origin: { x: 0, y: 0.65 },
    });
    burst({
      particleCount: 4,
      angle: 120,
      spread: 70,
      origin: { x: 1, y: 0.65 },
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  };

  frame();
}
